import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackUnlockButtonClick } from './tracking';
import { removeFromSpam } from '../../actions/chatOperations';
import { UnlockChatButton } from '../../components/UnlockChatButton';
import { chatListSelector, currentChatOpponentIdSelector, currentOpenChatSelector } from '../../selectors';
import { EAvailableActions } from '../../types/availableActions';
import { ERoute } from '../../types/route';

export const UnlockChatButtonContainer = () => {
  const currentChat = useSelector(currentOpenChatSelector);
  const opponentId = useSelector(currentChatOpponentIdSelector);
  const chatList = useSelector(chatListSelector);

  const dispatch = useDispatch();

  const { availableActions, chatId, offer } = currentChat || {};
  const { currentRoute } = chatList;

  const handleUnlockButtonClick = React.useCallback(() => {
    if (chatId) {
      dispatch(removeFromSpam(chatId));
      trackUnlockButtonClick(offer, opponentId);
    }
  }, [chatId, dispatch, offer, opponentId]);

  if (currentRoute !== ERoute.Spam || !availableActions?.includes(EAvailableActions.Unblock)) {
    return null;
  }

  return <UnlockChatButton onClick={handleUnlockButtonClick} />;
};
